import { Directive, OnInit, Renderer2, Output, EventEmitter, ElementRef, HostListener, inject, input } from '@angular/core';

@Directive({
    selector: '[appFilePicker]',
    standalone: false
})
export class FilePickerDirective implements OnInit {
    private el = inject(ElementRef);
    private renderer = inject(Renderer2);


    public readonly formatAccepted = input('');

    @Output()
    public filePick = new EventEmitter<ReadFile>();

    private _input: HTMLInputElement;

    ngOnInit(): void {
        this._input = this.renderer.createElement('input');
        this.renderer.setAttribute(this._input, 'type', 'file');
        this.renderer.setAttribute(this._input, 'accept', this.formatAccepted());
        this.renderer.setStyle(this._input, 'display', 'none');

        this.renderer.listen(this._input, 'change', (event: Event) => {
            const target = (event.target as HTMLInputElement);

            // use callback to avoid async/await and emit a ReadFile instead of a Promise<ReadFile>
            const onFileRead = (file: ReadFile) => { this.filePick.emit(file); };

            // when the promise is completed, reset the change event value
            this.readFile(target.files[0], onFileRead).finally(() => (target.value = ''));
        });
    }

    /**
     * Append the input element, click on it and remove it from the renderer
     */
    @HostListener('click')
    public compute() {
        this.renderer.appendChild(this.el.nativeElement, this._input);
        this._input.click();
        this.renderer.removeChild(this.el.nativeElement, this._input);
    }

    /**
     * Read a file, call the given callback when the reader has load the file content
     */
    private async readFile(file: File, onFileRead: (file: ReadFile) => void): Promise<void> {
        const reader = new FileReader();
        reader.onload = (event: ProgressEvent) => {
            onFileRead({
                name: file.name,
                size: file.size,
                type: file.type,
                content: (event.target as FileReader).result,
                underlyingFile: file
            });
        };
        reader.onerror = (event) => {
            throw (event);
        };
        reader.readAsDataURL(file);
    }
}

export interface ReadFile {
    name: string;
    size: number;
    type: string;
    content: any;
    underlyingFile: File;
}
